(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-tabs"] && !Shopify.designMode) return;
  try {
    
  class ReviewTabs extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[role="tabpanel"]');
      this.bar = this.querySelector('.reviews-tabs__bar');
      this.list = this.querySelector('[role="tablist"]');
      if (!this.panel || !this.list) return;

      // One tab per distinct "Fül" value, in the order of the cards
      const groups = new Map();
      this.panel.querySelectorAll('[data-review-tab]').forEach((card) => {
        if (!groups.has(card.dataset.reviewTab)) groups.set(card.dataset.reviewTab, card.dataset.reviewTabLabel || '');
      });

      this.list.replaceChildren();
      let index = 0;
      for (const [value, label] of groups) {
        index += 1;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reviews-tabs__tab';
        button.setAttribute('role', 'tab');
        button.id = this.panel.id + '-tab-' + index;
        button.dataset.tab = value;
        button.textContent = label;
        this.list.append(button);
      }
      this.tabs = Array.from(this.list.children);
      if (this.bar) this.bar.hidden = this.tabs.length < 2;
      this.setAttribute('data-ready', '');
      if (!this.tabs.length) return;

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.select(this.tabs[0], false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onClick = (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab) this.select(tab, true);
    };

    onKeydown = (event) => {
      const index = this.tabs.indexOf(document.activeElement);
      if (index < 0) return;
      let next = null;
      if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (event.key === 'Home') next = this.tabs[0];
      if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      next.focus();
      this.select(next, true);
    };

    select(tab, animate) {
      const value = tab.dataset.tab;
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      this.panel.setAttribute('aria-labelledby', tab.id);
      this.panel.querySelectorAll('[data-review-tab]').forEach((card) => {
        card.hidden = card.dataset.reviewTab !== value;
      });
      if (animate) {
        const list = this.list;
        const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
        list.scrollTo({ left, behavior: 'smooth' });
      }
      this.panel.scrollLeft = 0;
      if (animate) {
        this.panel.classList.remove('is-switching');
        void this.panel.offsetWidth;
        this.panel.classList.add('is-switching');
      }
    }
  }

  if (!customElements.get('review-tabs')) customElements.define('review-tabs', ReviewTabs);

  } catch(e) { console.error(e); }
})();
})();
